<template>
  <div>
    <table-card
      ref="datatable"
      module="Permission"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-4 md:mb-0"
          @click="add"
          >Add New Data</vs-button
        >
      </template>
    </table-card>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Privilege</label>
            <v-select
              :options="privilegeList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              v-model="input.privilege"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              label="Template Name"
              class="w-full"
              v-model="input.name"
            />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-checkbox v-model="input.default"
              >Set as Default Template</vs-checkbox
            >
          </div>
          <div v-if="input.default == true" class="vx-col sm:w-1/2 w-full">
            <vs-checkbox v-model="input.is_grant"
              >Grant to All Users</vs-checkbox
            >
          </div>
        </div>
        <div>
          <h5 class="text-center mb-3">Command Master</h5>
          <hr />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <ul class="mt-3">
                <li
                  v-for="(item, index) in menuList.slice(0, menuDividerIndex)"
                  :key="index"
                  class="mb-3"
                >
                  <vs-checkbox
                    v-model="input.permission"
                    @click="check(item)"
                    :vs-value="item.id"
                    :style="item.parent ? 'margin-left: 30px' : ''"
                    >{{ item.name }}</vs-checkbox
                  >
                </li>
              </ul>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <ul class="mt-3">
                <li
                  v-for="(item, index) in menuList.slice(
                    menuDividerIndex,
                    menuList.length
                  )"
                  :key="index"
                  class="mb-3"
                >
                  <vs-checkbox
                    v-model="input.permission"
                    @click="check(item)"
                    :vs-value="item.id"
                    :style="item.parent ? 'margin-left: 30px' : ''"
                    >{{ item.name }}</vs-checkbox
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button
              :disabled="isSubmit"
              id="submitBtn"
              class="mr-3 mb-2 vs-con-loading__container"
              @click="submit"
              >Submit</vs-button
            >
            <vs-button
              :disabled="isSubmit"
              v-show="action === 'store'"
              color="warning"
              type="border"
              @click="reset"
              class="mb-2"
              >Reset</vs-button
            >
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import TableCard from '@/components/TableCard'

export default {
  components: {
    vSelect,
    TableCard
  },

  data() {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,
      menuDividerIndex: 0,

      privilegeTemp: null,

      input: {
        id: null,
        privilege: null,
        name: null,
        default: false,
        permission: [],
        is_grant: false
      },
      notify: 'Server Error'
    }
  },

  computed: {
    headers() {
      return [
        [
          {
            label: 'Privilege',
            value: 'privilege',
            formatter: this.privilegeName
          },
          { label: 'Template Name', value: 'name' },
          {
            label: 'Permission',
            value: 'permission',
            formatter: this.permissionFormatter
          }
        ]
      ]
    },
    actions() {
      return [
        {
          name: 'Edit',
          action: this.edit,
          icon: 'icon-edit',
          color: 'success'
        },
        {
          name: 'Delete',
          action: this.del,
          icon: 'icon-trash',
          color: 'danger',
          condition: (data) => {
            return data.is_default !== 1
          }
        }
      ]
    },
    n_menu() {
      return this.menuList.length
    },
    privilege() {
      return this.input.privilege
    },
    privilegeList() {
      return this.$store.state.privilegeList
    },
    menuList() {
      return this.$store.state.Menu.data
    }
  },

  watch: {
    n_menu() {
      this.menuList.map((item, index) => {
        if (
          index >= this.n_menu / 2 &&
          !item.parent &&
          this.menuDividerIndex == 0
        ) {
          this.menuDividerIndex = index
        }
      })
    },
    privilege() {
      if (this.privilege) this.isDefault()
    }
  },

  async created() {
    await this.$store.dispatch('Menu/all')
  },
  mounted() {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        if (item === 'permission') this.input[item] = []
        else if (['default', 'is_grant'].indexOf(item) !== -1)
          this.input[item] = false
        else this.input[item] = null
      })
    },

    async isDefault() {
      await this.$store
        .dispatch('Permission/isDefault', this.input.privilege.value)
        .then((data) => {
          if (
            this.action === 'store' ||
            this.privilegeTemp != this.input.privilege.value
          ) {
            if (data.message.data === 0) this.input.default = true
            else this.input.default = false
          }
        })
    },

    check(item) {
      if (item.parent) {
        if (this.input.permission.indexOf(item.parent.id) === -1)
          this.input.permission.push(item.parent.id)
      } else {
        this.menuList.map((i) => {
          if (i.parent) {
            if (i.parent.id === item.id) {
              if (this.input.permission.indexOf(i.id) !== -1)
                this.input.permission.splice(
                  this.input.permission.indexOf(i.id),
                  1
                )
            }
          }
        })
      }
    },

    add() {
      if (this.action === 'update') this.reset()
      this.action = 'store'
      this.popupTitle = 'Add Permission Template'
      this.showPopup = true
    },

    async edit(id) {
      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit Permission Template'

      await this.$store.dispatch('Permission/detail', id).then((data) => {
        this.privilegeTemp = data.privilege
        this.input = {
          ...data,
          default: data.is_default,
          privilege: this.privilegeList.find((i) => {
            return i.value === data.privilege
          }),
          permission: data.permission ? JSON.parse(data.permission) : [],
          is_grant: false
        }
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')

      const formData = {
        ...this.input,
        privilege: this.input.privilege ? this.input.privilege.value : null,
        is_default: this.input.default,
        permission: JSON.stringify(this.input.permission),
        grant: this.input.is_grant
      }

      const { status, message } = await this.$store.dispatch(
        `Permission/${this.action}`,
        formData
      )
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if (status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Permission Template`,
        text: 'Are you sure want to Delete this Permission Template?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const { status, message } = await this.$store.dispatch(
        'Permission/delete',
        this.input.id
      )
      if (status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    privilegeName(data) {
      const privilege = this.privilegeList.find((i) => {
        return i.value == data
      })
      return privilege ? privilege.label : '-'
    },

    permissionFormatter(data) {
      let content = `<ul>`
      this.menuList.map((item) => {
        // if (data && JSON.parse(data).indexOf(item.id))
        content += `<li class="mb-2">
                        <div style="${
                          item.parent ? 'margin-left: 30px' : ''
                        }" class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default">
                          <input type="checkbox" disabled="disabled" ${
                            JSON.parse(data).indexOf(item.id) >= 0
                              ? 'checked'
                              : ''
                          }  class="vs-checkbox--input" value="true">
                          <span class="checkbox_x vs-checkbox">
                            <span class="vs-checkbox--check">
                              <i class="vs-icon notranslate icon-scale vs-checkbox--icon material-icons null">check</i>
                            </span>
                          </span>
                          <span class="con-slot-label">${item.name}</span>
                        </div>
                      </li>`
      })
      content += `</ul>`
      return content
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },

    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    }
  }
}
</script>
